(function () {
  'use strict';

  if (window.PWProductConceptV2) {
    window.PWProductConceptV2.init(document);
    return;
  }

  var ROOT_SELECTOR = 'product-page.product-concept[data-section-id]';
  var slice = Array.prototype.slice;

  function toInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }


  function parseJSON(element, fallback) {
    if (!element) return fallback;

    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function initProductConcept(root) {
    if (!root || root.getAttribute('data-pc-initialized') === 'true') return;
    root.setAttribute('data-pc-initialized', 'true');

    var sectionId = root.getAttribute('data-section-id') || '';
    var pdpCopy = parseJSON(root.querySelector('[data-pc-copy]'), {});
    function pdpText(key, values) {
      var result = pdpCopy[key] || '';
      Object.keys(values || {}).forEach(function (name) {
        result = result.split('_' + name + '_').join(String(values[name]));
      });
      return result;
    }


    function bottleLabel(quantity) {
      return Number(quantity) === 1 ? (root.dataset.pcUnitSingle || '') : (root.dataset.pcUnitPlural || '');
    }

    var cleanupTasks = [];

    function listen(target, eventName, handler, options) {
      if (!target) return;
      target.addEventListener(eventName, handler, options);
      cleanupTasks.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    /* Product gallery -------------------------------------------------- */
    var gallery = root.querySelector('[data-pc-gallery]');
    var mainImage = root.querySelector('[id^="ProductConceptMainImage-"]');
    var thumbnails = slice.call(root.querySelectorAll('[data-pc-media-thumbnail]'));

    if (gallery && thumbnails.length) {
      listen(gallery, 'click', function (event) {
        var thumbnail = event.target.closest('[data-pc-media-thumbnail]');
        if (!thumbnail || !gallery.contains(thumbnail)) return;

        thumbnails.forEach(function (item) {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });

        thumbnail.classList.add('is-active');
        thumbnail.setAttribute('aria-current', 'true');

        if (!mainImage) return;

        var source = thumbnail.getAttribute('data-full-src');
        var sourceSet = thumbnail.getAttribute('data-full-srcset');
        var sourceSizes = thumbnail.getAttribute('data-full-sizes');
        var alternativeText = thumbnail.getAttribute('data-full-alt');

        if (sourceSizes) mainImage.setAttribute('sizes', sourceSizes);
        if (source) mainImage.setAttribute('src', source);
        if (sourceSet) mainImage.setAttribute('srcset', sourceSet);
        if (alternativeText) mainImage.setAttribute('alt', alternativeText);
      });
    }

    /* Grape layout ----------------------------------------------------- */
    var grapeFull = root.querySelector('[data-pc-grape-full]');
    var grapeFact = root.querySelector('[data-pc-grape-fact]');
    var grapeFrame = 0;
    var grapeObserver = null;
    var lastGrapeContainerWidth = -1;

    function updateGrapeLayout() {
      if (!grapeFull || !grapeFact) return;

      grapeFact.classList.remove('pc-product-fact--grapes-wide');

      var grapeStyle = window.getComputedStyle(grapeFull);
      var lineHeight = parseFloat(grapeStyle.lineHeight);

      if (!isFinite(lineHeight)) {
        lineHeight = (parseFloat(grapeStyle.fontSize) || 13) * 1.4;
      }

      grapeFact.classList.toggle(
        'pc-product-fact--grapes-wide',
        grapeFull.scrollHeight > ((lineHeight * 1.5) + 2)
      );
    }

    function scheduleGrapeLayoutUpdate() {
      if (grapeFrame) window.cancelAnimationFrame(grapeFrame);
      grapeFrame = window.requestAnimationFrame(function () {
        grapeFrame = 0;
        updateGrapeLayout();
      });
    }

    if (grapeFull && grapeFact) {
      scheduleGrapeLayoutUpdate();

      if ('ResizeObserver' in window) {
        grapeObserver = new ResizeObserver(function (entries) {
          var width = entries[0] ? Math.round(entries[0].contentRect.width) : -1;
          if (width === lastGrapeContainerWidth) return;
          lastGrapeContainerWidth = width;
          scheduleGrapeLayoutUpdate();
        });
        grapeObserver.observe(root.querySelector('.pc-product-facts') || grapeFact);
        cleanupTasks.push(function () { grapeObserver.disconnect(); });
      } else {
        listen(window, 'resize', scheduleGrapeLayoutUpdate, { passive: true });
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          if (root.isConnected) scheduleGrapeLayoutUpdate();
        });
      }
    }

    /* Shared product state --------------------------------------------- */
    var qtyInput = root.querySelector('[id^="ProductConceptQty-"]');
    var minusButton = root.querySelector('[data-pc-qty-minus]');
    var plusButton = root.querySelector('[data-pc-qty-plus]');
    var stickyBar = document.getElementById('pc-sticky-atc-' + sectionId);
    var stickyButton = stickyBar ? stickyBar.querySelector('[data-pc-sticky-atc]') : null;
    var stickyQty = stickyBar ? stickyBar.querySelector('[id^="pc-sticky-qty-"]') : null;
    var stickyQuantityInput = stickyBar ? stickyBar.querySelector('[data-pc-sticky-qty-input]') : null;

    var quantityStep = Math.max(1, toInteger(root.getAttribute('data-quantity-step'), 1));
    var quantityMinimum = Math.max(1, toInteger(root.getAttribute('data-quantity-min'), 1));
    var quantityInitial = Math.max(quantityMinimum, toInteger(root.getAttribute('data-quantity-initial'), quantityMinimum));
    var isStepSixProduct = root.getAttribute('data-is-step-6') === 'true';
    var fallbackVariantId = root.getAttribute('data-current-variant-id') || '';
    var variantForm = root.querySelector('form[action*="/cart/add"]');
    var variantPicker = root.querySelector('[data-pc-variant-picker]');

    function syncSelectedVariantId() {
      var input = variantForm && variantForm.querySelector('input[name="id"]');
      if (input && fallbackVariantId) input.value = fallbackVariantId;
    }

    if (variantPicker) {
      syncSelectedVariantId();
      listen(variantForm, 'submit', syncSelectedVariantId, true);
      slice.call(variantPicker.querySelectorAll('[data-pc-variant-link]')).forEach(function (link) {
        var url = new URL(link.href, window.location.href);
        var previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        link.href = url.toString();
      });
    }

    var moneyFormat = root.getAttribute('data-money-format') || '';

    var priceWrap = root.querySelector('[data-pc-price-wrap]');
    var currentPriceElement = root.querySelector('[data-pc-current-price]');
    var compareElement = root.querySelector('[data-pc-compare]');
    var compareMoneyElement = root.querySelector('[data-pc-compare-money]');
    var savingElement = root.querySelector('[data-pc-saving]');
    var totalPriceElement = root.querySelector('[data-pc-total-price]');
    var totalCompareElement = root.querySelector('[data-pc-total-compare]');
    var staffelRows = slice.call(root.querySelectorAll('[data-pc-staffel-row]'));
    var staffelStatusElement = root.querySelector('[data-pc-staffel-status]');
    var staffelPricing = parseJSON(root.querySelector('[data-pc-staffel-pricing]'), []);

    var basePrice = priceWrap ? toInteger(priceWrap.getAttribute('data-base-price'), 0) : 0;
    var compareAtPrice = priceWrap ? toInteger(priceWrap.getAttribute('data-compare-at-price'), 0) : 0;
    var highestUnitPrice = Math.max(basePrice, compareAtPrice);

    staffelPricing = Array.isArray(staffelPricing) ? staffelPricing : [];
    staffelPricing = staffelPricing
      .filter(function (tier) {
        return tier && toInteger(tier.qty, 0) > 0 && toInteger(tier.unitPrice, -1) >= 0;
      })
      .map(function (tier) {
        var quantity = toInteger(tier.qty, 1);
        var freeQuantity = Math.max(0, toInteger(tier.freeQty, 0));

        if (freeQuantity >= quantity) freeQuantity = Math.max(0, quantity - 1);

        return {
          qty: quantity,
          percentageBasisPoints: Math.max(0, Math.min(10000, Number(tier.percentageBasisPoints) || 0)),
          unitPrice: toInteger(tier.unitPrice, 0),
          type: tier.type === 'free' ? 'free' : (tier.type === 'fixed' ? 'fixed' : 'percentage'),
          freeQty: freeQuantity,
          paidQty: Math.max(1, toInteger(tier.paidQty, quantity - freeQuantity))
        };
      })
      .sort(function (first, second) { return first.qty - second.qty; });

    function formatMoney(cents) {
      cents = Math.round(Number(cents) || 0);

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      return (cents / 100).toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatProminentPrice(cents) {
      cents = Math.max(0, Math.round(Number(cents) || 0));

      var whole = Math.floor(cents / 100).toLocaleString('nl-NL');
      var fraction = String(cents % 100).padStart(2, '0');

      return '<span class="visually-hidden">' + formatMoney(cents) + '</span>' +
        '<span class="pc-price-whole" aria-hidden="true">' + whole + ',</span>' +
        '<span class="pc-price-cents" aria-hidden="true">' + fraction + '</span>';
    }

    function getPriceStateForQuantity(quantity) {
      quantity = Math.max(1, toInteger(quantity, 1));

      var normalTotal = basePrice * quantity;
      var bestState = {
        totalPrice: normalTotal,
        unitPrice: basePrice,
        savingTotal: 0,
        freeBottles: 0,
        bundleCount: 0,
        activeTier: null
      };

      staffelPricing.forEach(function (tier) {
        if (quantity < tier.qty) return;

        var candidateTotal = normalTotal;
        var candidateFreeBottles = 0;
        var candidateBundleCount = 0;

        if (tier.type === 'free') {
          candidateBundleCount = Math.floor(quantity / tier.qty);
          candidateFreeBottles = candidateBundleCount * tier.freeQty;
          candidateTotal = Math.max(0, quantity - candidateFreeBottles) * basePrice;
        } else {
          candidateTotal = tier.percentageBasisPoints > 0
            ? Math.max(0, normalTotal - Math.floor((normalTotal * tier.percentageBasisPoints + 5000) / 10000))
            : tier.unitPrice * quantity;
        }

        var currentTierQuantity = bestState.activeTier ? bestState.activeTier.qty : 0;
        if (tier.qty >= currentTierQuantity) {
          bestState.totalPrice = candidateTotal;
          bestState.unitPrice = Math.ceil(candidateTotal / quantity);
          bestState.savingTotal = Math.max(0, normalTotal - candidateTotal);
          bestState.freeBottles = candidateFreeBottles;
          bestState.bundleCount = candidateBundleCount;
          bestState.activeTier = tier;
        }
      });

      return bestState;
    }

    function updateStaffelSelection(priceState) {
      staffelRows.forEach(function (row) {
        var rowQuantity = toInteger(row.getAttribute('data-staffel-qty'), 0);
        var rowKind = row.getAttribute('data-staffel-kind') || 'tiered';
        var activeKind = priceState.activeTier && priceState.activeTier.type === 'free' ? 'free' : 'tiered';
        var isActive = Boolean(priceState.activeTier && rowQuantity === priceState.activeTier.qty && rowKind === activeKind);

        row.classList.toggle('is-active', isActive);
        row.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updateStaffelStatus(quantity, priceState) {
      if (staffelStatusElement) { staffelStatusElement.textContent = ''; staffelStatusElement.hidden = true; }
      var element = root.querySelector('[data-pc-tier-condition]');
      if (!element) return;
      var nextTier = staffelPricing.find(function(tier) {
        return tier.qty > quantity && getPriceStateForQuantity(tier.qty).unitPrice < priceState.unitPrice;
      });
      element.replaceChildren();
      element.hidden = !nextTier;
      if (!nextTier) return;
      var amount = priceState.unitPrice - getPriceStateForQuantity(nextTier.qty).unitPrice;
      var template = element.getAttribute('data-extra-template');
      if (!template) return;
      var strong = document.createElement('strong');
      strong.textContent = element.getAttribute('data-extra-word');
      var amountText = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {style:'currency',currency:root.dataset.currencyCode || 'EUR'}).format(amount / 100);
      var message = template.replace('_count_',nextTier.qty - quantity).replace('_amount_',amountText);
      var parts = message.split('_extra_');
      element.append(document.createTextNode(parts[0]),strong,document.createTextNode(parts[1] || ''));
    }

    function updatePriceByQuantity(quantity) {
      if (!priceWrap || !currentPriceElement) return;

      var priceState = getPriceStateForQuantity(quantity);
      var savingPerBottle = Math.max(0, highestUnitPrice - priceState.unitPrice);
      if (stickyBar) {
        var stickyUnit = stickyBar.querySelector('[data-pc-sticky-unit]');
        if (stickyUnit) stickyUnit.innerHTML = formatMoney(priceState.unitPrice);
      }


      updateStaffelSelection(priceState);
      updateStaffelStatus(quantity, priceState);

      currentPriceElement.innerHTML = formatProminentPrice(priceState.unitPrice);
      if (priceWrap) priceWrap.dataset.pwPriceState = savingPerBottle > 0 ? 'sale' : 'regular';
      root.dataset.pwPriceState = savingPerBottle > 0 ? 'sale' : 'regular';
      if (totalPriceElement) totalPriceElement.innerHTML = formatMoney(priceState.totalPrice);

      if (totalCompareElement) {
        if (priceState.activeTier && priceState.savingTotal > 0) {
          totalCompareElement.innerHTML = formatMoney(basePrice * quantity);
          totalCompareElement.hidden = false;
        } else {
          totalCompareElement.hidden = true;
        }
      }

      if (savingPerBottle > 0 && compareElement && compareMoneyElement) {
        compareMoneyElement.innerHTML = formatMoney(highestUnitPrice);
        compareElement.style.display = '';

        if (savingElement) {
            savingElement.innerHTML = pdpText('savings', {amount: formatMoney(savingPerBottle), unit: bottleLabel(1)});
            savingElement.style.display = '';
        }
      } else {
        if (compareElement) compareElement.style.display = 'none';
        if (savingElement) savingElement.style.display = 'none';
      }
    }

    /* Quantity interaction -------------------------------------------- */
    var quantityEventIsInternal = false;

    function normalizeQuantity(value) {
      var quantity = toInteger(value, quantityMinimum);
      if (quantity < quantityMinimum) quantity = quantityMinimum;

      if (quantityStep > 1) {
        var remainder = (quantity - quantityMinimum) % quantityStep;
        if (remainder !== 0) quantity -= remainder;
        if (quantity < quantityMinimum) quantity = quantityMinimum;
      }

      return quantity;
    }

    function getQuantity() {
      return qtyInput ? normalizeQuantity(qtyInput.value) : quantityMinimum;
    }

    function syncQuantityState(value, notifyTheme) {
      var quantity = normalizeQuantity(value);

      if (qtyInput) qtyInput.value = String(quantity);
      if (stickyQty) stickyQty.value = String(quantity);

      updatePriceByQuantity(quantity);

      if (notifyTheme && qtyInput) {
        quantityEventIsInternal = true;
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityEventIsInternal = false;
      }

      return quantity;
    }

    function hydrateStickyOptions() {
      if (!stickyQty) return;

      var hasFreeTier = staffelPricing.some(function (tier) { return tier.type === 'free'; });
      if (!hasFreeTier) return;

      var values = [];
      var index;

      if (isStepSixProduct) {
        values = [6, 12, 18, 24, 30, 36];
      } else {
        for (index = 1; index <= 36; index += 1) values.push(index);
      }

      stickyQty.innerHTML = values.map(function (value) {
        var label = value + ' ' + bottleLabel(value);
        var priceState = getPriceStateForQuantity(value);

        if (priceState.freeBottles > 0) {
          label += ' · ' + pdpText('free_short', {count: priceState.freeBottles});
        }

        return '<option value="' + value + '">' + label + '</option>';
      }).join('');
    }

    hydrateStickyOptions();

    if (minusButton) {
      listen(minusButton, 'click', function () {
        syncQuantityState(getQuantity() - quantityStep, true);
      });
    }

    if (plusButton) {
      listen(plusButton, 'click', function () {
        syncQuantityState(getQuantity() + quantityStep, true);
      });
    }

    staffelRows.forEach(function (row) {
      listen(row, 'click', function () {
        var selectedQuantity = toInteger(row.getAttribute('data-staffel-qty'), 0);
        if (selectedQuantity > 0) syncQuantityState(selectedQuantity, true);
      });
    });

    if (qtyInput) {
      listen(qtyInput, 'input', function () {
        if (!quantityEventIsInternal) syncQuantityState(qtyInput.value, false);
      });
      listen(qtyInput, 'change', function () {
        syncQuantityState(qtyInput.value, false);
      });
    }

    if (stickyQty) {
      listen(stickyQty, 'change', function () {
        syncQuantityState(stickyQty.value, true);
      });
    }

    syncQuantityState(quantityInitial, false);

    /* Sale timer: only runs when this product actually has timer data -- */
    var saleTimerElement = root.querySelector('[data-pc-sale-timer]');
    var saleCountdownElement = root.querySelector('[data-pc-sale-countdown]');
    var saleTimerData = parseJSON(root.querySelector('[data-pc-sale-timers]'), {});
    var saleTimerTimeout = 0;
    var activeTimerVariantId = null;
    var activeTimerData = null;
    var timerValueElements = {};
    var timerUnitElements = {};

    function parseSaleTimerData(value) {
      var parsed = value;
      var attempt;

      for (attempt = 0; attempt < 2 && typeof parsed === 'string'; attempt += 1) {
        try {
          parsed = JSON.parse(parsed);
        } catch (error) {
          return null;
        }
      }

      if (!parsed || typeof parsed !== 'object') return null;

      var endAt = Number(parsed.end_at);
      if (!isFinite(endAt) || endAt <= 0) return null;

      return {
        saleId: parsed.sale_id || '',
        timerId: parsed.timer_id || '',
        endAt: endAt > 1000000000000 ? endAt : endAt * 1000
      };
    }

    Object.keys(saleTimerData).forEach(function (variantId) {
      saleTimerData[variantId] = parseSaleTimerData(saleTimerData[variantId]);
    });

    var hasSaleTimerData = Object.keys(saleTimerData).some(function (variantId) {
      return Boolean(saleTimerData[variantId]);
    });

    function getSelectedVariantId() {
      var variantInput = root.querySelector(
        '[data-update-block="variant-id-main"] input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );

      if (variantInput && variantInput.value) return String(variantInput.value);

      try {
        var urlVariantId = new URL(window.location.href).searchParams.get('variant');
        if (urlVariantId) return String(urlVariantId);
      } catch (error) {
        /* The server-rendered variant below remains the fallback. */
      }

      return String(fallbackVariantId);
    }

    function padTimerValue(value) {
      return String(value).padStart(2, '0');
    }

    function hideSaleTimer() {
      if (!saleTimerElement) return;
      saleTimerElement.hidden = true;
      saleTimerElement.classList.remove('is-urgent');
      activeTimerData = null;
    }

    function updateSaleTimer() {
      if (!saleTimerElement || !hasSaleTimerData) return false;

      var selectedVariantId = getSelectedVariantId();

      if (selectedVariantId !== activeTimerVariantId) {
        activeTimerVariantId = selectedVariantId;
        activeTimerData = saleTimerData[selectedVariantId] || null;
      }

      if (!activeTimerData) {
        hideSaleTimer();
        return false;
      }

      var remainingMilliseconds = activeTimerData.endAt - Date.now();

      if (remainingMilliseconds <= 0) {
        saleTimerData[selectedVariantId] = null;
        hideSaleTimer();
        return false;
      }

      var totalSeconds = Math.ceil(remainingMilliseconds / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var showSeconds = totalSeconds <= (72 * 60 * 60);
      var values = { days: days, hours: hours, minutes: minutes, seconds: seconds };

      Object.keys(values).forEach(function (unit) {
        if (timerValueElements[unit]) timerValueElements[unit].textContent = padTimerValue(values[unit]);
      });

      if (timerUnitElements.days) timerUnitElements.days.hidden = days <= 0;
      if (timerUnitElements.seconds) timerUnitElements.seconds.hidden = !showSeconds;

      saleTimerElement.classList.toggle('is-urgent', totalSeconds <= (24 * 60 * 60));
      saleTimerElement.hidden = false;

      if (saleCountdownElement) {
        var accessibleParts = [];
        if (days > 0) accessibleParts.push(pdpText(days === 1 ? 'timer_day' : 'timer_days', {count: days}));
        accessibleParts.push(pdpText(hours === 1 ? 'timer_hour' : 'timer_hours', {count: hours}));
        accessibleParts.push(pdpText(minutes === 1 ? 'timer_minute' : 'timer_minutes', {count: minutes}));
        if (showSeconds) accessibleParts.push(pdpText(seconds === 1 ? 'timer_second' : 'timer_seconds', {count: seconds}));
        saleCountdownElement.setAttribute('aria-label', accessibleParts.join(', '));
      }

      return true;
    }

    function scheduleSaleTimer() {
      if (saleTimerTimeout) window.clearTimeout(saleTimerTimeout);
      saleTimerTimeout = 0;

      if (document.hidden) return;

      if (updateSaleTimer()) {
        var delay = 1025 - (Date.now() % 1000);
        saleTimerTimeout = window.setTimeout(scheduleSaleTimer, delay);
      }
    }

    if (saleTimerElement && hasSaleTimerData) {
      ['days', 'hours', 'minutes', 'seconds'].forEach(function (unit) {
        timerValueElements[unit] = saleTimerElement.querySelector('[data-pc-sale-value="' + unit + '"]');
        timerUnitElements[unit] = saleTimerElement.querySelector('[data-pc-sale-unit="' + unit + '"]');
      });

      listen(root, 'change', scheduleSaleTimer);

      ['variant:change', 'variant-change', 'product:variant-change', 'theme:variant:change'].forEach(function (eventName) {
        listen(document, eventName, scheduleSaleTimer);
      });

      listen(document, 'visibilitychange', scheduleSaleTimer);
      cleanupTasks.push(function () {
        if (saleTimerTimeout) window.clearTimeout(saleTimerTimeout);
      });

      scheduleSaleTimer();
    } else if (saleTimerElement) {
      hideSaleTimer();
    }

    /* Anchored navigation --------------------------------------------- */
    function getSectionWrapper(element) {
      if (!element) return null;
      return element.closest('[id^="shopify-section-"]') ||
        element.closest('.shopify-section') ||
        element.closest('section');
    }

    function scrollToSection(element) {
      if (!element) return false;

      var sectionTarget = getSectionWrapper(element) || element;
      var scrollOffset = toInteger(root.getAttribute('data-scroll-offset'), 100);
      var targetTop = sectionTarget.getBoundingClientRect().top + window.pageYOffset - scrollOffset;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });

      if (sectionTarget.id) history.replaceState(null, '', '#' + sectionTarget.id);
      return true;
    }


    var readMore = root.querySelector('[data-pc-read-more]');
    var tasteDetailsLink = root.querySelector('[data-pc-taste-details]');

    function descriptionTarget() {
      return document.querySelector('.pw-origin-story') ||
        document.getElementById(root.getAttribute('data-description-anchor-id') || '') ||
        document.querySelector('.product-info-details, .product__description');
    }

    function tasteTarget() {
      return document.querySelector('.pw-taste-guide') ||
        document.getElementById(root.getAttribute('data-taste-anchor-id') || '');
    }

    function connectSectionLink(link, resolveTarget) {
      if (!link) return;
      var target = resolveTarget();
      link.hidden = !target;
      if (target && target.id) link.setAttribute('href', '#' + target.id);
      listen(link, 'click', function (event) {
        var currentTarget = resolveTarget();
        if (!currentTarget) return;
        event.preventDefault();
        scrollToSection(currentTarget);
      });
    }

    connectSectionLink(readMore, descriptionTarget);
    connectSectionLink(tasteDetailsLink, tasteTarget);


    var reviewScrollCleanup = null;
    function scrollToReviews() {
      var heading = document.querySelector('.pw-reviews__heading');
      if (!heading) return false;
      document.dispatchEvent(new CustomEvent('pw:reviews:load'));
      if (reviewScrollCleanup) reviewScrollCleanup();
      var frame = 0;
      var initial = true;
      var observer;
      var settleTimer;
      var stopTimer;
      var stopped = false;
      var main = document.querySelector('main');
      function offset() {
        var value = toInteger(root.getAttribute('data-scroll-offset'), 100);
        document.querySelectorAll('.pw-header, .pw-header__container--top, .pw-header__bottom').forEach(function (element) {
          var position = window.getComputedStyle(element).position;
          if (position !== 'fixed' && position !== 'sticky') return;
          var rect = element.getBoundingClientRect();
          if (rect.top <= 1 && rect.bottom > 0) value = Math.max(value, rect.bottom + 16);
        });
        return value;
      }
      function align(behavior) {
        if (stopped || !heading.isConnected) return;
        var delta = heading.getBoundingClientRect().top - offset();
        if (Math.abs(delta) > 2) window.scrollTo({top: Math.max(0, window.scrollY + delta), behavior: behavior});
      }
      function schedule() {
        if (initial || stopped || frame) return;
        frame = window.requestAnimationFrame(function () {frame = 0;align('instant');});
      }
      function settle() {
        if (stopped) return;
        initial = false;
        align('instant');
      }
      function cancel(event) {
        if (event && event.type === 'keydown' && !['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ','Tab','Escape'].includes(event.key)) return;
        if (stopped) return;
        stopped = true;
        if (observer) observer.disconnect();
        window.clearTimeout(settleTimer);
        window.clearTimeout(stopTimer);
        window.cancelAnimationFrame(frame);
        ['wheel','touchstart','pointerdown','keydown'].forEach(function (name) {window.removeEventListener(name,cancel,true);});
        reviewScrollCleanup = null;
      }
      reviewScrollCleanup = cancel;
      if ('ResizeObserver' in window && main) {
        observer = new ResizeObserver(schedule);
        Array.from(main.children).forEach(function (element) {
          if (element.contains(heading) || (element.compareDocumentPosition(heading) & Node.DOCUMENT_POSITION_FOLLOWING)) observer.observe(element);
        });
      }
      ['wheel','touchstart','pointerdown','keydown'].forEach(function (name) {window.addEventListener(name,cancel,{capture:true,passive:true});});
      if (heading.id) {
        var url = new URL(window.location.href);
        url.hash = heading.id;
        history.replaceState(history.state,'',url);
      }
      heading.setAttribute('tabindex','-1');
      heading.focus({preventScroll:true});
      align('instant');
      settleTimer = window.setTimeout(settle, 1000);
      stopTimer = window.setTimeout(cancel, 15000);
      return true;
    }
    function reviewTrigger(event) {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
      if (!(event.target instanceof Element)) return;
      var trigger = event.target.closest('.pc-review-slot .jdgm-preview-badge, .pc-review-link, [data-pc-review-summary]');
      if (!trigger || !root.contains(trigger)) return;
      if (event.type === 'click' && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) return;
      if (!scrollToReviews()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    listen(root, 'click', reviewTrigger, true);
    listen(root, 'keydown', reviewTrigger, true);
    var reviewSummary = root.querySelector('[data-pc-review-summary]');
    if (reviewSummary && document.querySelector('.pw-reviews__heading')) {
      reviewSummary.setAttribute('role','button');
      reviewSummary.setAttribute('tabindex','0');
    }
    cleanupTasks.push(function () {if (reviewScrollCleanup) reviewScrollCleanup();});

    /* Sticky add-to-cart and quantity sheet --------------------------- */
    var mainButton = root.querySelector('[data-js-product-add-to-cart]') || root.querySelector('.pc-buy-button');
    var stickyScrollFrame = 0;
    var stickySheet = document.getElementById('pc-sticky-staffel-sheet-' + sectionId);
    var stickySheetPanel = stickySheet ? stickySheet.querySelector('.pc-sticky-sheet__panel') : null;
    var stickySheetOptionsContainer = stickySheet ? stickySheet.querySelector('[data-pc-sticky-sheet-options]') : null;
    var stickySheetSubmit = stickySheet ? stickySheet.querySelector('[data-pc-sticky-sheet-submit]') : null;
    var stickySheetCloseButtons = stickySheet ? slice.call(stickySheet.querySelectorAll('[data-pc-sticky-sheet-close]')) : [];
    var stickySheetOptions = [];
    var stickySheetSelectedQuantity = 0;
    var stickySheetTrigger = null;
    var stickySheetHideTimer = 0;
    var stickyHasStaffel = Boolean(
      stickySheet &&
      stickyBar &&
      stickyBar.getAttribute('data-pc-sticky-has-staffel') === 'true'
    );

    function sheetPrice(value) {
      return String(value || '').replace(/[^0-9,.-]/g, '').trim();
    }

    function selectStickySheetOption(quantity) {
      var selectedQuantity = normalizeQuantity(quantity);

      stickySheetSelectedQuantity = selectedQuantity;
      stickySheetOptions.forEach(function (option) {
        var isSelected = Number(option.getAttribute('data-pc-sticky-sheet-qty')) === selectedQuantity;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      if (stickySheetSubmit) {
        stickySheetSubmit.textContent = root.dataset.pwPreorderActive === 'true'
          ? root.dataset.pwPreorderCount.replace('_count_', selectedQuantity).replace('_unit_', bottleLabel(selectedQuantity))
          : pdpText('order_count', {count: selectedQuantity, unit: bottleLabel(selectedQuantity)});
      }
    }

    function buildStickySheetOptions() {
      if (!stickySheetOptionsContainer || !stickyHasStaffel) return;

      var optionConfigs = [];
      var seenQuantities = {};

      function addOptionConfig(quantity, label, price) {
        quantity = Math.max(quantityMinimum, toInteger(quantity, quantityMinimum));
        if (seenQuantities[quantity]) return;

        seenQuantities[quantity] = true;
        optionConfigs.push({
          quantity: quantity,
          label: label || '',
          price: price || ''
        });
      }

      addOptionConfig(quantityMinimum, pdpText('standard_price'), sheetPrice(formatMoney(basePrice)));

      staffelRows.forEach(function (row) {
        var quantity = toInteger(row.getAttribute('data-staffel-qty'), 0);
        var labelElement = row.querySelector('.pc-staffel-label');
        var priceElement = row.querySelector('.pc-staffel-price strong');

        if (quantity > quantityMinimum) {
          addOptionConfig(
            quantity,
            labelElement ? (labelElement.textContent || '').trim() : '',
            priceElement ? sheetPrice(priceElement.textContent) : ''
          );
        }
      });

      if (staffelRows.length === 0) {
        staffelPricing.forEach(function (tier) {
          if (!tier || tier.qty <= quantityMinimum) return;

          var tierLabel = tier.type === 'free'
            ? (pdpText('free_offer', {paid: tier.paidQty, free: tier.freeQty}))
            : pdpText('quantity_savings');

          addOptionConfig(tier.qty, tierLabel, sheetPrice(formatMoney(tier.unitPrice)));
        });
      }

      optionConfigs.sort(function (first, second) {
        return first.quantity - second.quantity;
      });

      stickySheetOptionsContainer.innerHTML = '';
      stickySheetOptions = optionConfigs.map(function (config) {
        var quantity = config.quantity;
        var option = document.createElement('button');
        var copy = document.createElement('span');
        var quantityLabel = document.createElement('strong');
        var benefitLabel = document.createElement('span');
        var priceLabel = document.createElement('span');
        var radio = document.createElement('span');

        option.type = 'button';
        option.className = 'pc-sticky-sheet__option';
        option.setAttribute('role', 'radio');
        option.setAttribute('aria-checked', 'false');
        option.setAttribute('data-pc-sticky-sheet-qty', String(quantity));

        copy.className = 'pc-sticky-sheet__option-copy';
        quantityLabel.textContent = quantity + ' ' + bottleLabel(quantity);
        copy.appendChild(quantityLabel);

        if (config.label) {
          benefitLabel.className = 'pc-sticky-sheet__option-benefit';
          benefitLabel.textContent = config.label;
          copy.appendChild(benefitLabel);
        }

        option.appendChild(copy);

        if (config.price) {
          priceLabel.className = 'pc-sticky-sheet__option-price';
          priceLabel.textContent = config.price + ' / ' + bottleLabel(1);
          option.appendChild(priceLabel);
        }

        radio.className = 'pc-sticky-sheet__option-radio';
        radio.setAttribute('aria-hidden', 'true');
        option.appendChild(radio);

        listen(option, 'click', function () {
          selectStickySheetOption(quantity);
        });

        stickySheetOptionsContainer.appendChild(option);
        return option;
      });
    }


    function closeStickySheet(restoreFocus) {
      if (!stickySheet || stickySheet.hidden) return;

      stickySheet.classList.remove('is-open');
      stickySheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('pc-sticky-sheet-open');

      if (stickySheetHideTimer) window.clearTimeout(stickySheetHideTimer);
      stickySheetHideTimer = window.setTimeout(function () {
        if (!stickySheet.classList.contains('is-open')) stickySheet.hidden = true;
      }, 220);

      if (restoreFocus && stickySheetTrigger && typeof stickySheetTrigger.focus === 'function') {
        stickySheetTrigger.focus();
      }
    }

    function submitStickyOrder(quantity) {
      var selectedQuantity = quantity;

      if (selectedQuantity === undefined || selectedQuantity === null || selectedQuantity === '') {
        selectedQuantity = stickyQuantityInput && stickyQuantityInput.value
          ? stickyQuantityInput.value
          : (stickyQty ? stickyQty.value : quantityInitial);
      }

      syncQuantityState(selectedQuantity, true);

      if (mainButton) {
        mainButton.click();
        return;
      }

      var productForm = root.querySelector('form[action*="/cart/add"]');
      if (productForm) productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    buildStickySheetOptions();

    function setStickyVisibility(visible) {
      if (!stickyBar) return;
      stickyBar.classList.toggle('visible', visible);
      stickyBar.inert = !visible;
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if (stickyBar && mainButton) {
      var updateStickyVisibility = function () {
        stickyScrollFrame = 0;
        setStickyVisibility(mainButton.getBoundingClientRect().bottom < 0);
      };

      // Anchor jumps can skip the viewport entirely; an IntersectionObserver
      // alone then reports no threshold change. Check at most once per frame.
      var scheduleStickyVisibility = function () {
        if (!stickyScrollFrame) stickyScrollFrame = window.requestAnimationFrame(updateStickyVisibility);
      };

      listen(window, 'scroll', scheduleStickyVisibility, { passive: true });
      listen(window, 'resize', scheduleStickyVisibility, { passive: true });
      scheduleStickyVisibility();
    }

    if (stickyButton) {
      listen(stickyButton, 'click', function () {
        submitStickyOrder();
      });
    }

    stickySheetCloseButtons.forEach(function (button) {
      listen(button, 'click', function () { closeStickySheet(true); });
    });

    if (stickySheetSubmit) {
      listen(stickySheetSubmit, 'click', function () {
        if (!stickySheetSelectedQuantity) return;

        closeStickySheet(false);
        submitStickyOrder(stickySheetSelectedQuantity);
      });
    }

    if (stickySheet) {
      listen(document, 'keydown', function (event) {
        if (stickySheet.hidden) return;
        if (event.key === 'Escape') closeStickySheet(true);
        if (event.key !== 'Tab' || !stickySheetPanel) return;
        var focusable = slice.call(stickySheetPanel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'));
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || document.activeElement === stickySheetPanel)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    var feedbackTimer = 0;
    var feedbackButtons = [mainButton, stickyButton];

    function setButtonState(button, state) {
      if (!button) return;
      button.classList.toggle('is-loading', state === 'loading');
      button.classList.toggle('is-success', state === 'success');
      if (state === 'loading') {
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-label', root.dataset.pcLoadingLabel);
      } else {
        button.removeAttribute('aria-busy');
        button.setAttribute('aria-label', state === 'success' ? root.dataset.pcSuccessLabel : root.dataset.pcOrderLabel);
      }
    }

    listen(root, 'pw:cart-pending', function () {
      window.clearTimeout(feedbackTimer);
      feedbackButtons.forEach(function (button) { setButtonState(button, 'loading'); });
      if (stickyButton) stickyButton.disabled = true;
    });

    listen(root, 'pw:cart-result', function (event) {
      var success = Boolean(event.detail && event.detail.success);
      feedbackButtons.forEach(function (button) { setButtonState(button, success ? 'success' : 'default'); });
      if (stickyButton) stickyButton.disabled = Boolean(mainButton && mainButton.disabled);
      if (success) {
        feedbackTimer = window.setTimeout(function () {
          feedbackButtons.forEach(function (button) { setButtonState(button, 'default'); });
        }, 1400);
      }
    });

    cleanupTasks.push(function () { window.clearTimeout(feedbackTimer); });

    root._pcCleanup = function () {
      if (grapeFrame) window.cancelAnimationFrame(grapeFrame);
      if (stickyScrollFrame) window.cancelAnimationFrame(stickyScrollFrame);
      cleanupTasks.forEach(function (task) { task(); });
      cleanupTasks = [];
      root.removeAttribute('data-pc-initialized');
    };
  }

  function initWithin(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches(ROOT_SELECTOR)) initProductConcept(scope);
    if (!scope.querySelectorAll) return;

    slice.call(scope.querySelectorAll(ROOT_SELECTOR)).forEach(initProductConcept);
  }

  window.PWProductConceptV2 = { init: initWithin };

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;

    var root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + sectionId + '"]');
    if (root && typeof root._pcCleanup === 'function') root._pcCleanup();
  });
})();

/*
 * PDP enhancements kept separate from the core controller above.
 *
 * The core owns price calculation, the form submit and cart-drawer behaviour.
 * This module only renders the adjacent UI (sticky quantity display,
 * fulfilment, free-bottle copy and shipping progress).  Keeping that boundary
 * prevents a visual enhancement from changing the add-to-cart flow.
 */
(function () {
  'use strict';

  if (window.PWProductConceptEnhancements) {
    window.PWProductConceptEnhancements.init(document);
    return;
  }

  var ROOT_SELECTOR = 'product-page.product-concept[data-section-id]';
  var slice = Array.prototype.slice;

  function asNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  }

  function parseJSON(element, fallback) {
    if (!element) return fallback;

    try {
      return JSON.parse(element.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function findRoot(scope) {
    if (!scope) return null;
    if (scope.matches && scope.matches(ROOT_SELECTOR)) return scope;
    return scope.querySelector ? scope.querySelector(ROOT_SELECTOR) : null;
  }

  function initProductConceptEnhancements(root) {
    if (!root || root.getAttribute('data-pc-enhancements-initialized') === 'true') return;
    root.setAttribute('data-pc-enhancements-initialized', 'true');

    var sectionId = root.getAttribute('data-section-id') || '';
    var pdpCopy = parseJSON(root.querySelector('[data-pc-copy]'), {});
    function pdpText(key, values) {
      var result = pdpCopy[key] || '';
      Object.keys(values || {}).forEach(function (name) {
        result = result.split('_' + name + '_').join(String(values[name]));
      });
      return result;
    }

    var cleanupTasks = [];
    var renderFrame = 0;
    var nudgeReadyFrame = 0;
    var fastShippingRefreshTimer = 0;
    var delayedRenderTimers = [];

    function listen(target, eventName, handler, options) {
      if (!target) return;
      target.addEventListener(eventName, handler, options);
      cleanupTasks.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function observe(observer) {
      if (!observer) return;
      cleanupTasks.push(function () { observer.disconnect(); });
    }

    function bottleLabel(quantity) {
      return Number(quantity) === 1 ? (root.dataset.pcUnitSingle || '') : (root.dataset.pcUnitPlural || '');
    }

    function normaliseQuantity(value) {
      var minimum = Math.max(1, asNumber(root.dataset.quantityMin, 1));
      var step = Math.max(1, asNumber(root.dataset.quantityStep, 1));
      var quantity = asNumber(value, minimum);

      if (quantity < minimum) quantity = minimum;

      if (step > 1) {
        var remainder = (quantity - minimum) % step;
        if (remainder !== 0) quantity -= remainder;
        if (quantity < minimum) quantity = minimum;
      }

      return quantity;
    }

    var stickyBar = document.getElementById('pc-sticky-atc-' + sectionId);
    var stickyTotals = stickyBar ? stickyBar.querySelectorAll('[data-pc-sticky-total]') : [];
    var stickySelect = stickyBar ? stickyBar.querySelector('[id^="pc-sticky-qty-"]') : null;
    var stickyQuantity = stickyBar ? stickyBar.querySelector('[data-pc-sticky-quantity]') : null;
    var stickyQuantityInput = stickyBar ? stickyBar.querySelector('[data-pc-sticky-qty-input]') : null;
    var stickyMinus = stickyBar ? stickyBar.querySelector('[data-pc-sticky-qty-minus]') : null;
    var stickyPlus = stickyBar ? stickyBar.querySelector('[data-pc-sticky-qty-plus]') : null;
    var quantityInput = root.querySelector('[id^="ProductConceptQty-"]');
    var totalPrice = root.querySelector('[data-pc-total-price]');
    var priceWrap = root.querySelector('[data-pc-price-wrap]');

    function currentQuantity() {
      var rawValue = quantityInput
        ? quantityInput.value
        : (stickySelect ? stickySelect.value : root.dataset.quantityInitial);
      return normaliseQuantity(rawValue);
    }

    function ensureStickyOption(quantity) {
      if (!stickySelect) return;

      var value = String(quantity);
      var option = slice.call(stickySelect.options).find(function (item) {
        return item.value === value;
      });

      if (option) return;

      option = document.createElement('option');
      option.value = value;
      option.textContent = quantity + ' ' + bottleLabel(quantity);
      stickySelect.appendChild(option);
    }

    function renderStickyQuantity(quantity) {
      if (!stickyQuantity) return;

      quantity = normaliseQuantity(quantity);
      if (stickyQuantityInput) {
        stickyQuantityInput.value = String(quantity);
        stickyQuantityInput.min = String(Math.max(1, asNumber(root.dataset.quantityMin, 1)));
        stickyQuantityInput.step = String(Math.max(1, asNumber(root.dataset.quantityStep, 1)));
      }
      if (stickyMinus) stickyMinus.disabled = quantity <= Math.max(1, asNumber(root.dataset.quantityMin, 1));
      stickyQuantity.setAttribute('aria-label', pdpText('quantity_count', {count: quantity, unit: bottleLabel(quantity)}));
    }

    function syncStickyQuantityFromMain() {
      var quantity = currentQuantity();
      ensureStickyOption(quantity);
      if (stickySelect) stickySelect.value = String(quantity);
      renderStickyQuantity(quantity);
    }

    function setStickyQuantityFromUser(value) {
      if (!stickySelect) return;

      var quantity = normaliseQuantity(value);
      ensureStickyOption(quantity);
      stickySelect.value = String(quantity);
      stickySelect.dispatchEvent(new Event('change', { bubbles: true }));
      renderStickyQuantity(quantity);
    }

    function syncStickyTotal() {
      if (!stickyTotals.length || !totalPrice) return;

      var formattedTotal = (totalPrice.textContent || '')
        .replace(/[^0-9,.-]/g, '')
        .trim();
      if (!formattedTotal) return;
      stickyTotals.forEach(function (element) {
        if (element.textContent !== formattedTotal) element.textContent = formattedTotal;
      });
    }

    if (stickyMinus) {
      listen(stickyMinus, 'click', function () {
        var step = Math.max(1, asNumber(root.dataset.quantityStep, 1));
        setStickyQuantityFromUser(currentQuantity() - step);
      });
    }

    if (stickyPlus) {
      listen(stickyPlus, 'click', function () {
        var step = Math.max(1, asNumber(root.dataset.quantityStep, 1));
        setStickyQuantityFromUser(currentQuantity() + step);
      });
    }

    if (stickyQuantityInput) {
      listen(stickyQuantityInput, 'change', function () {
        setStickyQuantityFromUser(stickyQuantityInput.value);
      });
    }

    /* Fulfilment ------------------------------------------------------- */
    var variants = parseJSON(root.querySelector('[data-pc-fulfilment-variants]'), {});
    var stockSummary = root.querySelector('[data-pc-stock-summary]');
    var stockHeadline = root.querySelector('[data-pc-stock-headline]');
    var stockDetail = root.querySelector('[data-pc-stock-detail]');
    var stockIndicator = root.querySelector('[data-pc-stock-indicator]');
    var stockCard = root.querySelector('[data-pc-fulfilment-stock]');
    var pickup = root.querySelector('[data-pc-pickup-info]');
    var pickupText = root.querySelector('[data-pc-pickup-text]');
    var deliveryInfo = root.querySelector('[data-pc-delivery-info]');
    var deliveryDetail = root.querySelector('[data-pc-delivery-detail]');
    var freeBottleBenefit = root.querySelector('[data-pc-free-bottle-benefit]');
    var freeBottleBenefitText = root.querySelector('[data-pc-free-bottle-benefit-text]');
    var freeOfferButtons = slice.call(root.querySelectorAll('[data-pc-repeatable-free-offer]'));
    var staffelPricing = parseJSON(root.querySelector('[data-pc-staffel-pricing]'), []);
    var shippingNudge = root.querySelector('[data-pc-shipping-nudge]');
    var nudgeTrack = root.querySelector('[data-pc-shipping-track]');
    var nudgeFill = root.querySelector('[data-pc-shipping-fill]');
    var nudgeShippingBenefit = root.querySelector('[data-pc-shipping-benefit="shipping"]');
    var nudgeTrunkrsBenefit = root.querySelector('[data-pc-shipping-benefit="trunkrs"]');
    var nudgeMessage = root.querySelector('[data-pc-shipping-message]');
    var basePrice = priceWrap ? Math.max(0, asNumber(priceWrap.getAttribute('data-base-price'), 0)) : 0;
    var cartSubtotalCents = shippingNudge
      ? Math.max(0, asNumber(shippingNudge.dataset.cartSubtotalCents, 0))
      : 0;

    if (!variants || typeof variants !== 'object') variants = {};

    staffelPricing = Array.isArray(staffelPricing) ? staffelPricing : [];
    staffelPricing = staffelPricing
      .filter(function (tier) {
        return tier && asNumber(tier.qty, 0) > 0 && asNumber(tier.unitPrice, -1) >= 0;
      })
      .map(function (tier) {
        var quantity = asNumber(tier.qty, 1);
        var freeQuantity = Math.max(0, asNumber(tier.freeQty, 0));

        if (freeQuantity >= quantity) freeQuantity = Math.max(0, quantity - 1);

        return {
          qty: quantity,
          unitPrice: asNumber(tier.unitPrice, 0),
          type: tier.type === 'free' ? 'free' : (tier.type === 'fixed' ? 'fixed' : 'percentage'),
          freeQty: freeQuantity,
          paidQty: Math.max(1, asNumber(tier.paidQty, quantity - freeQuantity))
        };
      })
      .sort(function (first, second) { return first.qty - second.qty; });

    function currentVariantId() {
      var input = root.querySelector(
        '[data-update-block="variant-id-main"] input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );

      if (input && input.value) return String(input.value);

      try {
        var urlVariantId = new URL(window.location.href).searchParams.get('variant');
        if (urlVariantId) return String(urlVariantId);
      } catch (error) {
        /* The server-rendered ID below remains the fallback. */
      }

      return String(root.dataset.currentVariantId || '');
    }

    function fallbackFulfilmentVariant() {
      return {
        available: root.dataset.availability !== 'false',
        inventoryTracked: root.dataset.pcInventoryTracked === 'true',
        inventoryQuantity: asNumber(root.dataset.pcInventoryQty, 0),
        inventoryPolicy: root.dataset.pcInventoryPolicy || 'deny'
      };
    }

    function activeFulfilmentVariant() {
      var variant = variants[currentVariantId()];
      return variant && typeof variant === 'object' ? variant : fallbackFulfilmentVariant();
    }

    function deliveryDaysLabel() {
      var days = asNumber(root.dataset.pcDeliveryDays, 0);

      if (days > 0) return pdpText(days === 1 ? 'business_day' : 'business_days', {count: days});
      return pdpText('several_days');
    }

    function getFastShippingLabel() {
      var now = new Date();
      var amsterdamNow = now;
      var day;
      var timeNumber;

      try {
        amsterdamNow = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      } catch (error) {
        /* The local browser time is a safe fallback when Intl is unavailable. */
      }

      day = amsterdamNow.getDay();
      timeNumber = (amsterdamNow.getHours() * 100) + amsterdamNow.getMinutes();

      if (day === 6 || (day === 5 && timeNumber >= 1600)) {
        return root.dataset.pcShippingMonday || pdpText('ship_monday');
      }

      if (day === 0 || timeNumber >= 1600) {
        return root.dataset.pcShippingTomorrow || pdpText('ship_tomorrow');
      }

      return root.dataset.pcShippingToday || pdpText('ship_today');
    }

    function setDelivery(visible, detail) {
      if (!deliveryInfo) return;

      var hasDetail = Boolean(visible && detail);

      deliveryInfo.hidden = !visible;
      deliveryInfo.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (deliveryDetail) {
        deliveryDetail.textContent = hasDetail ? detail : '';
        deliveryDetail.hidden = !hasDetail;
      }
    }

    function setPickup(text, visible) {
      if (!pickup || !pickupText) return;

      pickup.hidden = !visible;
      pickup.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (visible) pickupText.textContent = text;
    }

    function setStockState(state) {
      if (stockCard) stockCard.dataset.stockState = state;
      if (stockSummary) stockSummary.dataset.stockState = state;
      if (stockIndicator) stockIndicator.dataset.stockState = state;
    }

    function setStockCopy(headline, detail) {
      if (stockHeadline) stockHeadline.textContent = headline;
      if (!stockDetail) return;

      stockDetail.textContent = detail || '';
      stockDetail.hidden = !detail;
    }

    function parseMoneyToCents(value) {
      var raw = String(value || '').replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
      var comma = raw.lastIndexOf(',');
      var dot = raw.lastIndexOf('.');
      var decimalIndex = Math.max(comma, dot);
      var normalised;

      if (!raw) return 0;

      if (decimalIndex > -1 && raw.length - decimalIndex <= 3) {
        normalised = raw.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' +
          raw.slice(decimalIndex + 1).replace(/[.,]/g, '');
      } else {
        normalised = raw.replace(/[.,]/g, '');
      }

      return Math.max(0, Math.round((Number(normalised) || 0) * 100));
    }

    function formatMoney(cents) {
      var currency = root.dataset.currencyCode || 'EUR';

      try {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Math.max(0, cents) / 100);
      } catch (error) {
        return '€' + (Math.max(0, cents) / 100).toLocaleString('nl-NL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }

    function formatThreshold(cents) {
      return '€' + Math.round(Math.max(0, cents) / 100).toLocaleString('nl-NL');
    }

    function priceStateForQuantity(quantity) {
      quantity = Math.max(1, normaliseQuantity(quantity));
      basePrice = priceWrap
        ? Math.max(0, asNumber(priceWrap.getAttribute('data-base-price'), basePrice))
        : basePrice;

      var normalTotal = basePrice * quantity;
      var bestState = {
        totalPrice: normalTotal,
        freeBottles: 0,
        activeTier: null
      };

      staffelPricing.forEach(function (tier) {
        if (quantity < tier.qty) return;

        var candidateTotal = normalTotal;
        var candidateFreeBottles = 0;

        if (tier.type === 'free') {
          var bundles = Math.floor(quantity / tier.qty);
          candidateFreeBottles = bundles * tier.freeQty;
          candidateTotal = Math.max(0, quantity - candidateFreeBottles) * basePrice;
        } else {
          candidateTotal = tier.unitPrice * quantity;
        }

        var currentTierQuantity = bestState.activeTier ? bestState.activeTier.qty : 0;
        if (candidateTotal < bestState.totalPrice ||
          (candidateTotal === bestState.totalPrice && tier.qty > currentTierQuantity)) {
          bestState.totalPrice = candidateTotal;
          bestState.freeBottles = candidateFreeBottles;
          bestState.activeTier = tier;
        }
      });

      return bestState;
    }

    function selectionTotalCents(quantity) {
      if (quantity === currentQuantity() && totalPrice) {
        var displayedTotal = parseMoneyToCents(totalPrice.textContent);
        if (displayedTotal > 0) return displayedTotal;
      }

      return priceStateForQuantity(quantity).totalPrice;
    }

    function updateFreeOfferActionLabels() {
      freeOfferButtons.forEach(function (button) {
        var label = button.getAttribute(
          button.classList.contains('is-active')
            ? 'data-pc-free-offer-add-label'
            : 'data-pc-free-offer-choose-label'
        );

        if (label) button.setAttribute('aria-label', label);
      });
    }

    function renderFreeBottleBenefit() {
      var priceState = priceStateForQuantity(currentQuantity());
      var freeBottles = Math.max(0, asNumber(priceState.freeBottles, 0));
      var active = Boolean(
        priceState.activeTier &&
        priceState.activeTier.type === 'free' &&
        freeBottles > 0
      );

      if (priceWrap) priceWrap.classList.remove('is-free-offer-active');

      if (freeBottleBenefit && freeBottleBenefitText) {
        freeBottleBenefit.hidden = true;
        if (active) {
          freeBottleBenefitText.textContent = pdpText('free_benefit', {count: freeBottles, unit: bottleLabel(freeBottles)});
        }
      }

      updateFreeOfferActionLabels();
    }

    function setNudgeVisibility() {
      if (!shippingNudge) return;

      shippingNudge.hidden = false;
      if (shippingNudge.dataset.ready === 'true') return;

      if (nudgeReadyFrame) window.cancelAnimationFrame(nudgeReadyFrame);
      nudgeReadyFrame = window.requestAnimationFrame(function () {
        nudgeReadyFrame = 0;
        if (root.isConnected && !shippingNudge.hidden) shippingNudge.dataset.ready = 'true';
      });
    }

    function setNudgeBenefit(benefit, complete) {
      if (!benefit) return;

      var label = benefit.querySelector('[data-pc-shipping-benefit-label]');
      var labelText = label ? label.textContent.trim() : pdpText('shipping_benefits');

      benefit.dataset.complete = complete ? 'true' : 'false';
      benefit.setAttribute('aria-label', pdpText(complete ? 'benefit_achieved' : 'benefit_pending', {benefit: labelText}));
    }

    function setNudgeMessage(message) {
      if (!nudgeMessage) return;

      nudgeMessage.textContent = message || '';
      nudgeMessage.hidden = !message;
    }

    function setShippingNudgeProgress(prospectiveCents, freeShippingCents, maximumCents) {
      if (!nudgeTrack || !nudgeFill) return;

      var visibleValue = Math.max(0, Math.min(prospectiveCents, maximumCents));
      var progress = 0;
      var isComplete = prospectiveCents >= maximumCents;
      var accessibleText = isComplete
        ? pdpText('shipping_complete')
        : pdpText('shipping_thresholds', {amount: formatMoney(prospectiveCents), postnl: formatThreshold(freeShippingCents), trunkrs: formatThreshold(maximumCents)});

      /* The visual track intentionally gives both milestones equal space:
         €100 is centred and €150 stays at the far right. */
      if (maximumCents <= freeShippingCents) {
        progress = maximumCents > 0 ? visibleValue / maximumCents : 0;
      } else if (visibleValue <= freeShippingCents) {
        progress = 0.5 * (visibleValue / freeShippingCents);
      } else {
        progress = 0.5 + (0.5 * ((visibleValue - freeShippingCents) / (maximumCents - freeShippingCents)));
      }

      progress = Math.max(0, Math.min(1, progress));

      nudgeFill.style.transform = 'scaleX(' + progress.toFixed(4) + ')';
      nudgeTrack.setAttribute('aria-valuenow', String(Math.round(visibleValue / 100)));
      nudgeTrack.setAttribute('aria-valuemax', String(Math.round(maximumCents / 100)));
      nudgeTrack.setAttribute('aria-valuetext', accessibleText);
    }

    function renderShippingNudge() {
      if (!shippingNudge) return;

      var quantity = currentQuantity();
      var freeShippingCents = Math.max(1, asNumber(shippingNudge.dataset.freeShippingCents, 10000));
      var eveningDeliveryCents = Math.max(
        freeShippingCents + 1,
        asNumber(shippingNudge.dataset.eveningDeliveryCents, 15000)
      );
      var selectionTotal = selectionTotalCents(quantity);
      var prospectiveTotal = Math.max(0, cartSubtotalCents + selectionTotal);
      var shippingComplete;
      var trunkrsComplete;

      shippingComplete = prospectiveTotal >= freeShippingCents;
      trunkrsComplete = prospectiveTotal >= eveningDeliveryCents;

      shippingNudge.dataset.state = trunkrsComplete ? 'complete' : (shippingComplete ? 'trunkrs' : 'postnl');
      setNudgeBenefit(nudgeShippingBenefit, shippingComplete);
      setNudgeBenefit(nudgeTrunkrsBenefit, trunkrsComplete);
      setNudgeMessage(
        trunkrsComplete
          ? ''
          : pdpText('remaining_shipping', {amount: formatMoney(Math.max(0, (shippingComplete ? eveningDeliveryCents : freeShippingCents) - prospectiveTotal)), benefit: pdpText(shippingComplete ? 'free_evening' : 'free_postnl')})
      );
      setShippingNudgeProgress(prospectiveTotal, freeShippingCents, eveningDeliveryCents);
      setNudgeVisibility();
    }

    function renderFulfilment() {

      var variant = activeFulfilmentVariant();
      var quantity = currentQuantity();
      var tracked = Boolean(variant.inventoryTracked);
      var inventory = Math.max(0, asNumber(variant.inventoryQuantity, 0));
      var policy = variant.inventoryPolicy || 'deny';
      var canContinueSelling = tracked && policy === 'continue';
      var productAvailable = Boolean(variant.available) || canContinueSelling;
      var state = 'unavailable';
      var deliveryTiming = '';
      var preorderActive = root.dataset.pwPreorderConfigured === 'true' && canContinueSelling && inventory < quantity;

      if (!productAvailable) {
        setStockCopy(pdpText('unavailable'), '');
        setPickup('', false);
      } else if (preorderActive) {
        state = 'backorder';
        setStockCopy(root.dataset.pwPreorderStock, root.dataset.pwPreorderMessage);
        setPickup('', false);
      } else if (!tracked) {
        state = 'untracked';
        setStockCopy(pdpText('available'), '');
        setPickup('', false);
        deliveryTiming = getFastShippingLabel();
      } else if (inventory >= quantity) {
        state = 'in-stock';
        setStockCopy(pdpText('in_stock', {count: inventory, unit: bottleLabel(inventory)}), '');
        setPickup(pdpText('pickup_today'), true);
        deliveryTiming = getFastShippingLabel();
      } else if (canContinueSelling) {
        state = inventory > 0 ? 'partial' : 'backorder';
        setStockCopy(
          inventory > 0
            ? pdpText('partial_stock', {stock: inventory, count: quantity, unit: bottleLabel(quantity)})
            : pdpText('backorder'),
          pdpText('dispatch_days', {days: deliveryDaysLabel()})
        );
        setPickup(pdpText('pickup_days', {days: deliveryDaysLabel()}), true);
      } else {
        state = inventory > 0 ? 'partial-deny' : 'unavailable';
        setStockCopy(
          inventory > 0
            ? pdpText('maximum_stock', {count: inventory, unit: bottleLabel(inventory)})
            : pdpText('unavailable'),
          ''
        );
        setPickup('', false);
      }

      root.dataset.pwPreorderActive = String(preorderActive);
      if (root.dataset.pwPreorderConfigured === 'true') {
        var preorderLabel = preorderActive ? root.dataset.pwPreorderLabel : pdpText('order');
        root.dataset.pcOrderLabel = preorderLabel;
        root.querySelectorAll('[data-pw-preorder-notice], [data-pw-preorder-badge]').forEach(function (node) { node.hidden = !preorderActive; });
        root.querySelectorAll('[data-pw-preorder-property]').forEach(function (node) { node.disabled = !preorderActive; });
        root.querySelectorAll('[data-js-product-add-to-cart-text]').forEach(function (node) {
          node.textContent = productAvailable ? preorderLabel : pdpText('unavailable');
        });
        var preorderSticky = document.querySelector('[data-pc-sticky-for="' + root.dataset.sectionId + '"]');
        if (preorderSticky) {
          preorderSticky.querySelectorAll('[data-pw-preorder-sticky]').forEach(function (node) { node.hidden = !preorderActive; });
          preorderSticky.querySelectorAll('[data-pc-sticky-text]').forEach(function (node) { node.textContent = preorderLabel; });
        }
      }
      setStockState(state);
      setDelivery(productAvailable, deliveryTiming);
      var specsTiming = deliveryTiming;
      if (preorderActive) {
        specsTiming = root.dataset.pwPreorderMessage;
      } else if (state === 'partial' || state === 'backorder') {
        specsTiming = pdpText('dispatch_days', {days: deliveryDaysLabel()});
      } else if (state === 'partial-deny') {
        specsTiming = pdpText('maximum_stock', {count: inventory, unit: bottleLabel(inventory)});
      } else if (state === 'unavailable') {
        specsTiming = pdpText('unavailable');
      }
      document.querySelectorAll('[data-current-delivery][data-product-id="' + root.dataset.productId + '"]').forEach(function (node) {
        node.textContent = specsTiming;
        node.dataset.pwFulfilment = state;
        node.classList.toggle('pw-specs__delivery--in-stock', state === 'in-stock' || state === 'untracked');
      });
      renderFreeBottleBenefit();
      renderShippingNudge();
    }

    function renderAll() {
      syncStickyTotal();
      syncStickyQuantityFromMain();
      renderFulfilment();
    }

    function scheduleRender() {
      if (renderFrame) return;

      renderFrame = window.requestAnimationFrame(function () {
        renderFrame = 0;
        if (root.isConnected) renderAll();
      });
    }

    function scheduleDelayedRender(delay) {
      var timer = window.setTimeout(function () {
        delayedRenderTimers = delayedRenderTimers.filter(function (item) { return item !== timer; });
        scheduleRender();
      }, delay);
      delayedRenderTimers.push(timer);
    }

    function scheduleFastShippingRefresh() {
      var delay = 60000 - (Date.now() % 60000) + 25;

      if (fastShippingRefreshTimer) window.clearTimeout(fastShippingRefreshTimer);
      fastShippingRefreshTimer = window.setTimeout(function () {
        fastShippingRefreshTimer = 0;
        scheduleRender();
        scheduleFastShippingRefresh();
      }, delay);
    }

    if (totalPrice && 'MutationObserver' in window) {
      var totalObserver = new MutationObserver(scheduleRender);
      totalObserver.observe(totalPrice, { childList: true, characterData: true, subtree: true });
      observe(totalObserver);
    }

    if (quantityInput) {
      listen(quantityInput, 'input', scheduleRender);
      listen(quantityInput, 'change', scheduleRender);
    }

    listen(root, 'input', scheduleRender);
    listen(root, 'change', scheduleRender);

    if (stickySelect) listen(stickySelect, 'change', scheduleRender);

    /* Theme variant controls differ per storefront. The normal input/change
       events cover most themes; the named events cover common product scripts. */
    [
      'variant:change',
      'variant:changed',
      'product:variant-change',
      'product:variant-changed',
      'theme:variant:change'
    ].forEach(function (eventName) {
      listen(root, eventName, scheduleRender);
      listen(document, eventName, scheduleRender);
    });

    [
      'cart:change',
      'cart:updated',
      'ajaxProduct:added',
      'product:added'
    ].forEach(function (eventName) {
      listen(document, eventName, function (event) {
        var detail = (event && event.detail) || {};
        var cart = detail.cart || detail;

        if (cart && Number.isFinite(Number(cart.total_price))) {
          cartSubtotalCents = Math.max(0, Number(cart.total_price));
        }

        scheduleRender();
      });
    });

    /* Repeat a free-bottle bundle instead of resetting to its first quantity.
       Capture phase intentionally prevents the core's one-time row handler. */
    listen(root, 'click', function (event) {
      var target = event.target;
      var row = target && target.closest
        ? target.closest('[data-pc-repeatable-free-offer]')
        : null;

      if (!row || !root.contains(row) || !quantityInput) return;

      var packQuantity = asNumber(row.getAttribute('data-staffel-qty'), 0);
      if (packQuantity < 1) return;

      var current = currentQuantity();
      var next = current >= packQuantity ? current + packQuantity : packQuantity;

      event.preventDefault();
      event.stopImmediatePropagation();

      quantityInput.value = String(normaliseQuantity(next));
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    /* Some theme controls update a hidden variant input after their click.
       Two small, cancellable queues cover that without observing all DOM text. */
    listen(root, 'click', function () {
      scheduleDelayedRender(0);
      scheduleDelayedRender(100);
    }, true);

    renderAll();
    scheduleFastShippingRefresh();

    root._pcEnhancementCleanup = function () {
      if (renderFrame) window.cancelAnimationFrame(renderFrame);
      if (nudgeReadyFrame) window.cancelAnimationFrame(nudgeReadyFrame);
      if (fastShippingRefreshTimer) window.clearTimeout(fastShippingRefreshTimer);
      delayedRenderTimers.forEach(function (timer) { window.clearTimeout(timer); });
      delayedRenderTimers = [];
      cleanupTasks.forEach(function (task) { task(); });
      cleanupTasks = [];
      root.removeAttribute('data-pc-enhancements-initialized');
      delete root._pcEnhancementCleanup;
    };
  }

  function initWithin(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches(ROOT_SELECTOR)) initProductConceptEnhancements(scope);
    if (!scope.querySelectorAll) return;
    slice.call(scope.querySelectorAll(ROOT_SELECTOR)).forEach(initProductConceptEnhancements);
  }

  function destroyWithin(scope) {
    if (!scope) return;

    var roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(slice.call(scope.querySelectorAll(ROOT_SELECTOR)));

    roots.forEach(function (root) {
      if (typeof root._pcEnhancementCleanup === 'function') root._pcEnhancementCleanup();
    });
  }

  window.PWProductConceptEnhancements = {
    init: initWithin,
    destroy: destroyWithin
  };

  initWithin(document);

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRoot(event.target);

    if (!root) {
      var sectionId = event.detail && event.detail.sectionId;
      if (sectionId) root = document.querySelector(ROOT_SELECTOR + '[data-section-id="' + sectionId + '"]');
    }

    if (root && typeof root._pcEnhancementCleanup === 'function') root._pcEnhancementCleanup();
  });
})();
